module.exports = __webpack_public_path__ + "media/packs/images/flags/LY-c9775f80f901363e19f1b02dcc2982d6.svg";